import { TMembershipLike } from '../types/TMembershipLike';
import { TTeamMemberOption } from '../types/TTeamMemberOption';

export const toTeamMemberOption = ({ id, User }: TMembershipLike): TTeamMemberOption => ({
  membershipId: id,
  userId: User.id,
  fullName: [User.name, User.lastname].filter(Boolean).join(' '),
  email: User.email,
});
